import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ProductsList from './ProductsList'

export default function Products() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/products" component={ProductsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}